import MaterialsApiService from "./api/MaterialsApiService";
import AuthService from "./api/AuthService";

export const createMaterialItem = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post('/material-items', {
      title: payload.title,
      type: payload.type,
      description: payload.description,
      file: payload.file,
      iframe_code: payload.iframeCode,
      color: payload.color,
      image: payload.image,
      audio: payload.audio,
      quizzes_ids: payload.quizzesIds,
      material_id: payload.materialId,
      scorm: payload.scorm
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const findMaterialItem = async (materialItemId, userToken) => {
  try {
    const response = await MaterialsApiService.get('/material-items/' + materialItemId, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar item', error);

    throw error;
  }
};

export const updateMaterialItem = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.materialItemId}/update`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar item', error);

    throw error;
  }
};

export const deleteMaterialItem = async (materialItemId, userToken) => {
  try {
    const response = await MaterialsApiService.delete('/material-items/' + materialItemId, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao deletar item', error);

    throw error;
  }
};

export const getMaterialItems = async (payload, userToken) => {
  try {
    let url = '/material-items?';

    if (payload.search) {
      url += `search=${payload.search}&`;
    }

    if (payload.materialId) {
      url += `material_id=${payload.materialId}&`;
    }

    if (payload.disciplineId) {
      url += `discipline_id=${payload.disciplineId}&`;
    }

    if (payload.page) {
      url += `page=${payload.page}&`;
    }

    if (payload.perPage) {
      url += `per_page=${payload.perPage}&`;
    }

    if (payload.exception) {
      url += `distinct_type=${payload.exception}&`
    }

    const response = await MaterialsApiService.get(url.slice(0, -1), {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar items:', error);
    throw error;
  }
}

export const duplicateMaterialItem = async (materialItemId, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${materialItemId}/duplicate`, null, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao duplicar item', error);

    throw error;
  }
}

export const removeQuiz = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.materialItemId}/remove-quiz`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao remover questão', error);

    throw error;
  }
}

export const getAttempts = async (payload, userToken) => {
  try {
    let url = `/material-items/${payload.materialItemId}/attempts?`;

    if (payload.name) {
      url += `name=${payload.name}&`;
    }

    if (payload.userId) {
      url += `user_id=${payload.userId}&`;
    }

    if (payload.status) {
      url += `status=${payload.status}&`;
    }

    if (payload.role) {
      url += `role=${payload.role}&`;
    }

    const response = await MaterialsApiService.get(url.slice(0, -1), {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar tentativas:', error);
    throw error;
  }
}

export const updateIndex = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.materialItemId}/index`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar índice', error);

    throw error;
  }
}

export const uploadMaterialItemFile = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/upload`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export const changeMaterialItemStatus = async (payload) => {
  try {
    const response = await MaterialsApiService.post(`/progress/material-items/${payload.requestData.materialItemId}/mark`, payload.requestData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + payload.userToken
      }
    })
    return response.data
  } catch {
    throw new Error("Erro ao alterar status de item de material, tente novamente!")
  }
}

export const downloadMaterialItemFile = async (payload) => {
  try {
    const response = await MaterialsApiService.get(`/download/companies/${payload.requestData.companyId}/users/${payload.requestData.userId}/file?url=${payload.requestData.fileURL}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + payload.userToken
      },
      responseType: 'blob'
    })
    return response.data
  } catch {
    throw new Error("Erro ao baixar arquivo! tente novamente")
  }
}

export const updateMaterialItemSettings = async (payload) => {
  try {
    const response = await MaterialsApiService.put(`/material-item-settings/${payload.settings.material_item_settings_id}`, payload.settings, {
      headers: {
        Authorization: 'Bearer ' + payload.userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar item', error);

    throw error;
  }
};

export const createMaterialItemSettings = async (payload) => {
  try {
    const response = await MaterialsApiService.post('/material-item-settings', payload.settings, {
      headers: {
        Authorization: 'Bearer ' + payload.userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar item', error);

    throw error;
  }
};

export const validateMaterialItemPassword = async (payload) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.materialItemId}/password`, payload.requestData, {
      headers: {
        Authorization: 'Bearer ' + payload.userToken
      }
    })

    return response.data
  } catch {
    throw new Error("Senha Inválida! Tente novamente")
  }
}

export const createAssigmentAnswer = async (payload) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.requestData.materialItemId}/submit`, payload.requestData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + payload.userToken
      }
    })

    return response.data
  } catch {
    throw new Error("Erro ao Salvar Tarefa! Tente novamente")
  }
}

export const evaluateAssigment = async (payload) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${payload.requestData.attemptId}/evaluate`, payload.requestData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + payload.userToken
      }
    })
    return response.data
  } catch {
    throw new Error("Erro ao Avaliar Tarefa! Tente novamente")
  }
}

export const moveMaterialItem = async (payload) => {
  try {
    const response = await MaterialsApiService.put(`/material-items/${payload?.materialItemId}/move`, payload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao mover item de material! Tente novamente")
  }
}

export const downloadMaterialItemFileWaterMark = async (materialItemId) => {
  try {
    const response = await MaterialsApiService.get(`/material-items/${materialItemId}/download`)
    return response.data
  } catch (error) {
    throw new Error("Ocorreu um erro ao baixar arquivo! Tente novamente")
  }
}

export const initializeExternalTool = async (toolId) => {
  try {
    const response = await MaterialsApiService.get(`/material-items/${toolId || null}/lti/launch`)
    return response.data
  } catch (error) {
    const errorMessage = error?.response?.data?.message || "Ocorreu um erro ao inicializar ferramenta! Tente novamente"
    throw new Error(errorMessage)
  }
}

export const validateExternalToolURL = async (toolURL) => {
  try {
    const response = await AuthService.get(`/lti-tools/check/url?url=${toolURL}`)
    return response.data
  } catch {
    throw new Error("URL de ferramenta externa inválida! Insira novamente")
  }
}

export const restrictMaterialItemToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${requestPayload?.materialItemId}/restrict-consumers`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao restringir item de material aos consumidores! Tente novamente")
  }
}

export const removeMaterialItemRestrictionToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/material-items/${requestPayload?.materialItemId}/restrict-consumers/remove`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao remover restrição do item de material aos consumidores! Tente novamente")
  }
}

export const updateQuestionnaireWeights = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(
      `/material-items/${payload.materialItemId}/update-questionnaire-weights`, 
      {
        weights: payload.weights,
        grades_by_weight_enabled: payload.gradesByWeightEnabled
      },
      {
        headers: {
          Authorization: 'Bearer ' + userToken
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar pesos das questões', error);
    throw error;
  }
}

export default {
  restrictMaterialItemToConsumers,
  removeMaterialItemRestrictionToConsumers,
  updateQuestionnaireWeights,
  downloadMaterialItemFileWaterMark,
  moveMaterialItem,
  validateExternalToolURL,
  initializeExternalTool,
  downloadMaterialItemFile,
  changeMaterialItemStatus,
  createMaterialItem,
  findMaterialItem,
  updateMaterialItem,
  deleteMaterialItem,
  getMaterialItems,
  duplicateMaterialItem,
  removeQuiz,
  getAttempts,
  updateIndex,
  uploadMaterialItemFile,
  updateMaterialItemSettings,
  createMaterialItemSettings,
  validateMaterialItemPassword,
  createAssigmentAnswer,
  evaluateAssigment
}